module.exports = __webpack_public_path__ + "assets/img/inner_data_title.94d0c035.svg";